import React, { useState, useEffect } from 'react';
import SubHeader from '../QuestionConfigure/SubHeader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Select,
    MenuItem
} from '@material-ui/core';
import './RolesConfigure.css';
import LoaderComponent from '../LoaderComponent';
import config from "./config.json";

import { fetchRolesConfiguration, AddRolesConfiguration } from '../../api/api';

const RolesConfiguration = (props) => {
    const [role, setRole] = useState(config.role[0]);
    let permissionsList = {
            "Existing Client": ["No Permissions Available for Existing Client"],
            "Notifications": ["No Permissions Available for Notifications"],
            "Users": ["No Permissions Available for Users"],
            "New Client": ["No Permissions Available for New Client"]
        };
    const [isLoading, setLoading] = useState(false);
    let [selectedRolePermissions, setSelectedRolePermissions] = useState({});
    let [selectedItems, setSelectedItems] = useState([]);
    let [configuredPermissions, setConfiguredPermissions] = useState([{
        "role": "Super Admin",
        "permissions": permissionsList
    }]);
    const [customer, setCustomer] = useState(props.match.params.id)

    useEffect(() => {

        const loadConfiguration = async () => {
            setLoading(true);
            try {
                const data = await fetchRolesConfiguration({ customer: customer });
                if (data && data.response?.length > 0) {
                    toast.info(`Roles Configuration fetched successfully.`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000
                    });
                    let permissionsData = data.response.map((item) => {
                        if(!item.permissions?.hasOwnProperty("Existing Client")){
                            item.permissions["Existing Client"] = [];
                        }
                       return item;
                    })
                    setConfiguredPermissions(permissionsData);
                }
            } catch (error) {
                toast.error('Error fetching roles configuration', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1000
                });
                console.error("Error fetching roles configuration:", error);
            }
            setLoading(false);
        };

        loadConfiguration();


    }, [])


    useEffect(() => {
        let configureJson = {
            "role": role,
            "permissions": permissionsList
        }
        setConfiguredPermissions((prev) => {
            let exists = prev.find((item) => item.role === role);
            if (!exists) {
                return [...prev, configureJson];
            }
            return [...prev];
        });

    }, [role]);


    useEffect(() => {
        let rolePermissions = configuredPermissions.find((item) => item.role === role)?.permissions;
        let mainItems = Object.keys(rolePermissions || {}).map((acc) => {
            return acc;
        });
        setSelectedRolePermissions(rolePermissions);
        setSelectedItems(mainItems);

    }, [configuredPermissions]);

    // Handle main menu checkbox toggle
    const handleMainToggle = (event, section) => {
        if (event.target.checked) {
            selectedRolePermissions[section] = [`No Permissions Available for ${section}`];
        } else {
            delete selectedRolePermissions[section];
        }
        configuredPermissions = configuredPermissions.map((item) => {
            if (item.role === role) {
                item.permissions = selectedRolePermissions
                return item;
            }
            return item;
        });
        setConfiguredPermissions(configuredPermissions);
    };

    // Handle checkbox toggle
    const handleToggle = (event, section, option) => {
        if (event.target.checked) {
            selectedRolePermissions[section] = [...(selectedRolePermissions[section] || []), option];
        } else {
            selectedRolePermissions[section] = selectedRolePermissions[section].filter((opt) => opt !== option);
        }
        if(selectedRolePermissions[section].length > 1){ 
            selectedRolePermissions[section] = selectedRolePermissions[section].filter((opt) => opt !== `No Permissions Available for ${section}`);
        }
        if(selectedRolePermissions[section].length === 0){
            selectedRolePermissions[section].push(`No Permissions Available for ${section}`);
        };
        configuredPermissions = configuredPermissions.map((item) => {
            if (item.role === role) {
                item.permissions = selectedRolePermissions
                return item;
            }
            return item;
        });
        setConfiguredPermissions(configuredPermissions);
    };

    const saveChanges = async () => {
        setLoading(true); 
        try {
            const payload = {
                customer: customer,
                permissions_config: configuredPermissions
            };
            const response = await AddRolesConfiguration(payload);
           
            if (response && response.status === "failed") {
                toast.error(`Error saving roles configuration.`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000
                });
            } else {
                toast.info(`Roles Configuration submitted successfully.`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000
                });
            }



        } catch (error) {
            toast.error('Error saving roles configuration:', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
            });
            console.error("Error saving roles configuration:", error);
        }
        setLoading(false);
    };
    const orgType = props.match.params.orgType
    return (
        <div className="container-fluid mb-5" style={{ marginTop: '3rem' }}>
            <SubHeader {...props.match} title="Roles Configuration" id={props.match.params.id} config={props.match.params.Config} subConfig={props.match.params.subConfig} DownloadToolConfiguration={() => { }} UploadToolConfiguration={() => { }} loadingHandler={() => { }} isLoading={() => { }} />
            <LoaderComponent isLoading={isLoading} />
            <div className="form-group field-row">
                <label className="col-sm-1 col-form-label  ">Roles: </label>
                <div className="col-sm-4">
                    <Select value={role} label="Role" onChange={(e) => setRole(e.target.value)}>
                        {config.role.map((r, idx) => (
                            <MenuItem key={idx} value={r}>
                                {r}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <div className="col-sm-2">
                    <button type="button" className="btn btn-primary font-weight-bold btn-block" onClick={() => saveChanges()}>
                        Save Changes
                    </button>
                </div>
            </div>
            <div className="container_role">
                <div className="card_role">
                    {config.sections.map((section, index) => (
                        section.orgTypes.includes(orgType?.toString()) && (
                            <fieldset className={section.options.length > 0 ? 'fieldset_role' : ''} key={index}>
                                <legend className='legend_role'><input type="checkbox" onChange={(e) => handleMainToggle(e, section.title)} checked={selectedItems.includes(section?.title)} disabled={section.alwaysEnabled} />
                                    &nbsp;  <b>{section.title}</b></legend>
                                <div className="options_role">
                                    {section.options.map((option, idx) => (
                                        <label key={idx}><input key={idx} value={option} type="checkbox"
                                            disabled={!selectedItems?.includes(section?.title)}
                                            checked={selectedRolePermissions && selectedRolePermissions[section.title]?.includes(option)}
                                            onChange={(e) => handleToggle(e, section.title, option)} /> {option}</label>
                                    ))}
                                </div>
                            </fieldset>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RolesConfiguration;
